<script>
  export let onClick
  export let disabled = false
  export let position = "left" // or "right"

  $: innerStyle = position === "left"
    ? "transform: translate(-50%, -50%) rotate(-90deg)"
    : "transform: translate(-50%, -50%) rotate(90deg)"
</script>

<div class="side-button-container">
  <button
    class="side-button"
    on:click={onClick}
    disabled={disabled}
  >
    <span class="side-button-inner" style={innerStyle}>
      <slot />
    </span>
  </button>
</div>

<style>
  .side-button-container {
    position: relative;
    background-color: #e2e2e2;
    border-radius: 10px;
    padding: .5rem;
    display: flex;
    align-items: center; /* center the button vertically within the container */
    justify-content: center; /* center horizontally if needed */
  }

  .side-button {
    width: 50px;
    height: 100%;
  }

  .side-button-inner {
    position: absolute;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    left: 50%;
    color: #888888;
  }
</style>